/**
 * Step 3 — Configurazione asset (dominio, IP, email).
 * Identico allo store StepAssetConfig.
 */
import React from 'react';
import { Globe, Plus, Trash2 } from 'lucide-react';

const TIPO_ASSET_OPTIONS = [
  { value: 'dominio', label: 'Dominio' },
  { value: 'ip', label: 'Indirizzo IP' },
  { value: 'email', label: 'Email' },
];

export default function StepAssetMSSP({ data, onChange, errors }) {
  const assets = data.asset || [{ asset: '', tipo_asset: 'dominio' }];

  const updateAsset = (index, field, value) => {
    const updated = assets.map((a, i) =>
      i === index ? { ...a, [field]: value } : a
    );
    onChange({ ...data, asset: updated });
  };

  const isDuplicate = (value, tipo, excludeIndex) => {
    if (!value.trim()) return false;
    return assets.some((a, i) =>
      i !== excludeIndex &&
      a.asset.trim().toLowerCase() === value.trim().toLowerCase() &&
      a.tipo_asset === tipo
    );
  };

  const addAsset = () => {
    if (assets.length >= 10) return;
    onChange({ ...data, asset: [...assets, { asset: '', tipo_asset: 'dominio' }] });
  };

  const removeAsset = (index) => {
    if (assets.length <= 1) return;
    onChange({ ...data, asset: assets.filter((_, i) => i !== index) });
  };

  const fieldError = (field) => {
    const err = errors?.[`ordine.${field}`] || errors?.[field];
    if (!err) return null;
    const msg = Array.isArray(err) ? err[0] : err;
    return <p className="text-red-500 text-xs mt-1">{msg}</p>;
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center gap-3 mb-4">
        <Globe className="w-6 h-6 text-yellow-600" />
        <h2 className="text-xl font-bold text-gray-900">Asset da Monitorare</h2>
      </div>

      <p className="text-sm text-gray-600 mb-4">
        Inserisci i domini, indirizzi IP o email che vuoi monitorare (max 10).
      </p>

      <div className="flex-1 min-h-0 overflow-y-auto pr-2">
        <div className="space-y-3">
          {assets.map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <select
                value={item.tipo_asset}
                onChange={(e) => updateAsset(index, 'tipo_asset', e.target.value)}
                className="border border-gray-300 rounded-lg px-3 py-2 text-sm w-36 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              >
                {TIPO_ASSET_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>

              <div className="flex-1">
                <input
                  type="text"
                  value={item.asset}
                  onChange={(e) => updateAsset(index, 'asset', e.target.value)}
                  className={`w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
                    isDuplicate(item.asset, item.tipo_asset, index)
                      ? 'border-red-400 bg-red-50'
                      : 'border-gray-300'
                  }`}
                  placeholder={
                    item.tipo_asset === 'dominio'
                      ? 'es. esempio.it'
                      : item.tipo_asset === 'ip'
                        ? 'es. 192.168.1.1'
                        : 'es. info@esempio.it'
                  }
                />
                {isDuplicate(item.asset, item.tipo_asset, index) && (
                  <p className="text-red-500 text-xs mt-1">Asset duplicato</p>
                )}
              </div>

              {assets.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeAsset(index)}
                  className="p-2 text-red-400 hover:text-red-600 transition-colors"
                  title="Rimuovi asset"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
        </div>

        {fieldError('asset')}

        {assets.length < 10 && (
          <button
            type="button"
            onClick={addAsset}
            className="mt-3 flex items-center gap-2 text-sm text-yellow-600 hover:text-yellow-800 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Aggiungi asset
          </button>
        )}
      </div>
    </div>
  );
}
